import { hoverDynamic } from './hover';

export default class Calendar {
  constructor() {
    this.container = document.querySelector('.calendar-container');
    this.programsContainer = document.querySelector('.selected-date-programs');
    if (!this.container || !this.programsContainer) return;
    
    this.calendarWrapper = this.container.querySelector('.calendar-wrapper');
    this.ajaxUrl = this.container.getAttribute('data-ajax-url');
    this.selectedDate = this.container.getAttribute('data-selected-date');
    
    // Check if we're on a schedule page
    this.isSchedulePage = this.checkIfSchedulePage();
    
    if (window.scheduleInitialData) {
      this.currentMonth = window.scheduleInitialData.month;
      this.currentYear = window.scheduleInitialData.year;
      this.selectedDate = window.scheduleInitialData.selectedDate;
      this.earliestDate = window.scheduleInitialData.earliestDate;
      this.latestDate = window.scheduleInitialData.latestDate;
    }
    
    this.init();
  }
  
  checkIfSchedulePage() {
    const pathname = window.location.pathname;
    // Check if URL contains /schedule/ or /en/schedule/
    return pathname.includes('/schedule/');
  }

  init() {
    this.loadCalendar();
    this.loadPrograms(this.selectedDate);
    if (this.isSchedulePage) {
      this.updateUrl();
    }
  }

  async loadCalendar() {
    const formData = new FormData();
    formData.append('action', 'load_calendar');
    formData.append('month', this.currentMonth);
    formData.append('year', this.currentYear);
    formData.append('selected_date', this.selectedDate);
    formData.append('earliest_date', this.earliestDate || '');
    formData.append('latest_date', this.latestDate || '');

    try {
      const response = await fetch(this.ajaxUrl, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      
      if (data.success) {
        this.calendarWrapper.innerHTML = data.data.html;
        this.bindCalendarEvents();
      }
    } catch (error) {
      console.error('Error loading calendar:', error);
    }
  }

  async loadPrograms(date) {
    const formData = new FormData();
    formData.append('action', 'load_programs');
    formData.append('date', date);

    try {
      const response = await fetch(this.ajaxUrl, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      
      if (data.success) {
        this.programsContainer.innerHTML = data.data.html;
        this.selectedDate = date;
        this.container.setAttribute('data-selected-date', date);
        this.updateSelectedDate();

        const hov = this.programsContainer.querySelectorAll('a, button, .hov');
        for (let i = 0; i < hov.length; i++) {
          const el = hov[i];
          hoverDynamic(el);
        }
      }
    } catch (error) {
      console.error('Error loading programs:', error);
    }
  }

  bindCalendarEvents() {
    const prevButton = this.calendarWrapper.querySelector('.calendar-prev');
    const nextButton = this.calendarWrapper.querySelector('.calendar-next');
    
    if (prevButton && !prevButton.disabled) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigateMonth(prevButton);
      });
    }
    
    if (nextButton && !nextButton.disabled) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigateMonth(nextButton);
      });
    }
    
    const dayLinks = this.calendarWrapper.querySelectorAll('.calendar-day-link');
    dayLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const date = link.getAttribute('data-date');
        if (date) {
          this.selectDate(date);
        }
      });
    });
  }

  navigateMonth(button) {
    this.currentMonth = parseInt(button.getAttribute('data-month'));
    this.currentYear = parseInt(button.getAttribute('data-year'));
    this.loadCalendar();
  }

  selectDate(date) {
    this.selectedDate = date;
    this.loadPrograms(date);
    this.updateSelectedDate();
    if (this.isSchedulePage) {
      this.updateUrl();
    }
  }

  updateSelectedDate() {
    const previousSelected = this.calendarWrapper.querySelector('.calendar-day.is-selected');
    if (previousSelected) {
      previousSelected.classList.remove('is-selected');
    }

    const newSelected = this.calendarWrapper.querySelector(`[data-date="${this.selectedDate}"]`);
    if (newSelected && newSelected.closest('.calendar-day')) {
      newSelected.closest('.calendar-day').classList.add('is-selected');
    }
  }

  updateUrl() {
    const url = new URL(window.location);
    url.searchParams.set('date', this.selectedDate);
    url.searchParams.delete('month');
    url.searchParams.delete('year');
    window.history.replaceState({}, '', url);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Calendar();
});